import type { ThemeConfig } from './types'
import { next } from './themes/next'
import { marinaLoungeNew } from './themes/marina_lounge_new'
import { valentine } from './themes/valentine'
import { sky } from './themes/sky'
import { wellness } from './themes/wellness'
import { terras } from './themes/terras'
import { laguna } from './themes/laguna'
import { ducoJosper } from './themes/duco-josper'
import { slaak } from './themes/slaak'
import { byzoo } from './themes/byzoo'
import { menuc } from './themes/menu_c'
import { menub } from './themes/menu_b'
import { christmas } from './themes/christmas'

const themes: Record<ThemeName, ThemeConfig> = {
  'default': {},
  next,
  'marina_lounge_new': marinaLoungeNew,
  sky,
  wellness,
  valentine,
  terras,
  laguna,
  'duco': ducoJosper,
  slaak,
  byzoo,
  'menu-c': menuc,
  'menu-b': menub,
  christmas,
}

export function getThemeConfig(theme: ThemeName): ThemeConfig {
  return themes[theme] ?? {}
}
